/** Iconify icon id (e.g. mdi:calculator). Use with <Icon icon={...} /> from @iconify/react. */
export type ToolIconId = string;

export const freeTools = [
  {
    id: 'calculator',
    label: 'Social Media Calculator',
    icon: 'mdi:calculator' as ToolIconId,
    path: '/tools/social-media-calculator',
    color: '#4CAF50',
    description: 'Calculate optimal posting times and engagement rates',
    tier: 'free'
  },
  {
    id: 'hashtag',
    label: 'Hashtag Research',
    icon: 'mdi:tag-multiple' as ToolIconId,
    path: '/tools/hashtag-research',
    color: '#FF9800',
    description: 'Find trending hashtags for your content',
    tier: 'free'
  },
  {
    id: 'templates',
    label: 'Calendar Templates',
    icon: 'mdi:calendar-month' as ToolIconId,
    path: '/tools/calendar-templates',
    color: '#9C27B0',
    description: 'Pre-made content calendar templates',
    tier: 'free'
  },
  {
    id: 'audit',
    label: 'Social Media Audit',
    icon: 'mdi:chart-bar' as ToolIconId,
    path: '/tools/social-media-audit',
    color: '#F44336',
    description: 'Analyze your social media performance',
    tier: 'free'
  },
  {
    id: 'my-content',
    label: 'My Content',
    icon: 'mdi:extension' as ToolIconId,
    path: '/dashboard/content',
    color: '#2196F3',
    description: 'View and update engagement (likes, comments) for your content',
    tier: 'free'
  }
];

export const creatorTools = [
  {
    id: 'voice-tone',
    label: 'Voice & Tone Analyzer',
    icon: 'mdi:microphone' as ToolIconId,
    path: '/tools/voice-tone-analyzer',
    color: '#FF6B6B',
    description: 'Analyze your content\'s voice and tone for brand consistency',
    tier: 'creator'
  },
  {
    id: 'ai-content',
    label: 'AI Content Creation',
    icon: 'mdi:creation' as ToolIconId,
    path: '/tools/ai-content-creation',
    color: '#4ECDC4',
    description: 'Complete AI-powered content generation and optimization',
    tier: 'creator'
  }
];

export const proTools = [
  {
    id: 'advanced-analytics',
    label: 'Advanced Analytics',
    icon: 'mdi:chart-line' as ToolIconId,
    path: '/dashboard/analytics',
    color: '#6C5CE7',
    description: 'Comprehensive cross-platform analytics with AI insights',
    tier: 'pro'
  }
];

export const enterpriseTools = [
  {
    id: 'ai-suite',
    label: 'AI Content Suite',
    icon: 'mdi:robot' as ToolIconId,
    path: '/tools/ai-content-suite',
    color: '#E17055',
    description: 'Advanced AI-powered content generation for enterprise teams',
    tier: 'enterprise'
  }
];

/** Paths that redirect or gate to another path; map to same icon as the canonical tool path. */
const pathToIconOverrides: Record<string, string> = {
  '/tools/advanced-analytics': 'mdi:chart-line',
};

/** Get Iconify icon id for a tool path. Use the same icon on the tool's page as on the tools index. */
export function getToolIconForPath(path: string): string {
  if (pathToIconOverrides[path]) return pathToIconOverrides[path];
  const all = [...freeTools, ...creatorTools, ...proTools, ...enterpriseTools];
  const tool = all.find((t) => t.path === path);
  return tool?.icon ?? 'mdi:application';
}

export function getToolsForPlan(plan: string) {
  switch (plan) {
    case 'CREATOR':
      return [...freeTools, ...creatorTools];
    case 'PRO':
      return [...freeTools, ...creatorTools, ...proTools];
    case 'ENTERPRISE':
      return [...freeTools, ...creatorTools, ...proTools, ...enterpriseTools];
    default:
      return freeTools;
  }
}
